module.exports = __webpack_public_path__ + "static/QLEX-trilogy-desktop-3824c8102c29862b0dad9bc543410482.png";